import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  goToNextPage: false,
};

export default function funnelReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.GO_TO_NEXT_SCREEN: {
      return {
        ...state,
        goToNextPage: true,
      };
    }
    case actionTypes.RESET_NEXT_SCREEN_FLAG: {
      return {
        ...state,
        goToNextPage: false,
      };
    }

    default:
      return state;
  }
}

export const FUNNEL_STATE_KEY = 'funnel';
